import PropTypes from 'prop-types';
import FeatherIcon from 'feather-icons-react';
import { ButtonCheck, ButtonX } from '../../../style';

export const ActionsEditSummaryItem = ({ handleCancel, handleSave }) => {
  return (
    <>
      <ButtonX onClick={handleCancel} style={{ marginRight: '8px' }} type="text" shape="circle">
        <FeatherIcon icon="x" size={14} />
      </ButtonX>
      <ButtonCheck onClick={handleSave} type="text" shape="circle">
        <FeatherIcon icon="check" size={14} />
      </ButtonCheck>
    </>
  );
};

ActionsEditSummaryItem.propTypes = {
  handleCancel: PropTypes.func,
  handleSave: PropTypes.func,
};
